import { AddressBlock, StageKey, VendorOnboardingForm } from '../interfaces'
import { DEFAULT_DIAL_CODE } from './countries'

export const BRAND_CORAL = '#f2755f'
export const BRAND_CORAL_DARK = '#f06147'
/**
 * A near-white coral wash for focus rings. Written as a literal on purpose: this
 * repo's `primaryLight` (#f48977) is a tint of the same hue, far too saturated to
 * sit behind text.
 */
export const BRAND_CORAL_WASH = '#fef4f2'

export const STEPS: Array<{ key: StageKey; label: string; blurb: string }> = [
    { key: 'company', label: 'Company', blurb: 'Who you are' },
    { key: 'agreement', label: 'Agreement', blurb: 'GST certificate & signatory' },
    { key: 'invoicing', label: 'Invoicing', blurb: 'GST number & addresses' },
    { key: 'contacts', label: 'Contacts', blurb: 'People we should reach' },
    { key: 'review', label: 'Review', blurb: 'Check and submit' },
]

export const ACCEPT = '.pdf,.jpg,.jpeg,.png'
/** Discord's webhook cap is 10MB; 8 leaves headroom for multipart overhead. */
export const MAX_FILE_MB = 8
export const MAX_FILE_BYTES = MAX_FILE_MB * 1024 * 1024

export const DRAFT_KEY = 'casa:finance-onboarding:draft:v1'
export const COOLDOWN_KEY = 'casa:finance-onboarding:last-submit'
export const COOLDOWN_MS = 30_000

export const RECAPTCHA_ACTION = 'finance_onboarding'

export const emptyPhone = () => ({ dial: DEFAULT_DIAL_CODE, number: '' })

export const emptyAddress = (): AddressBlock => ({
    attention: '',
    country: 'India',
    street1: '',
    street2: '',
    city: '',
    state: '',
    pinCode: '',
    phone: emptyPhone(),
})

export const emptyContact = () => ({
    firstName: '',
    lastName: '',
    email: '',
    phone: emptyPhone(),
    sendInvoice: false,
})

export const defaultValues: VendorOnboardingForm = {
    companyName: '',
    panNumber: '',
    submitterEmail: '',
    gstCertificate: null,
    signingAuthorityName: '',
    signingAuthorityEmail: '',
    gstNumber: '',
    billing: emptyAddress(),
    sameAsBilling: true,
    shipping: emptyAddress(),
    contacts: [emptyContact()],
    website: '',
}

/** Fields validated before advancing past each step. */
export const FIELDS_BY_STEP: Record<StageKey, Array<keyof VendorOnboardingForm>> =
    {
        company: ['companyName', 'panNumber', 'submitterEmail'],
        agreement: [
            'gstCertificate',
            'signingAuthorityName',
            'signingAuthorityEmail',
        ],
        invoicing: ['gstNumber', 'billing', 'shipping'],
        contacts: ['contacts'],
        review: [],
    }
